import { gql } from '@apollo/client';
import { queryInsuranceCompanies } from 'next-common';

export const queryInsuranceCompaniesParsed = gql`
  ${queryInsuranceCompanies}
`;
